export class ActionError<ErrorType = any> {
  constructor(public message: string, public errorType?: ErrorType) {}
}

export function createActionError<ErrorType>(message: string, errorType?: ErrorType) {
  return new ActionError<ErrorType>(message, errorType);
}
